/**
 * Check if the value is a non-empty array
 * @param value - The value to check
 * @returns True if the value is a non-empty array, false otherwise
 */
export function isValidArray(value: unknown): boolean {
  if (!value) return false;
  return Array.isArray(value) && value.length > 0;
}
